import * as React from 'react';

export type SurveyColumnsProps = {
  columnConfig: [string, string];
  col1: React.ReactNode;
  col2: React.ReactNode;
};

const SurveyColumns = ({ columnConfig, col1, col2 }: SurveyColumnsProps) => (
  <div className="survey-columns">
    <div
      className="survey-columns__col"
      style={{ '--grid-column': columnConfig[0] } as React.CSSProperties}
    >
      {col1}
    </div>
    <div
      className="survey-columns__col"
      style={{ '--grid-column': columnConfig[1] } as React.CSSProperties}
    >
      {col2}
    </div>
  </div>
);

export default SurveyColumns;
